import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject, Subscriber } from 'rxjs';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { SharedValidators } from '../shared/validators/shared-validators';
@Component({
  selector: 'app-govt-servers-add-page',
  templateUrl: './govt-servers-add-page.component.html',
  styleUrls: ['./govt-servers-add-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatIcon,
    MatError,
    CommonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CommonPaginationComponent,
    NgxPaginationModule,
  ],
})
export class GovtServersAddPageComponent implements OnInit, OnDestroy {
  page = 1;
  size = 10;
  totalLength = 0;
  serverId = '';

  updateButton = false;

  firmwareList: {
    _id: string;
    firmwareVersion: string;
    fileName: string;
    description: string;
    expectedFirmwareVersion: string;
    createdBy: { fullName: string };
    createdAt: string;
  }[] = [];

  govtServersForm: FormGroup = this.formBuilder.group({
    state: new FormControl('', [SharedValidators.requiredAndNoEmptySpaces]),
    stateAbbreviation: new FormControl('', [
      SharedValidators.requiredAndNoEmptySpaces,
      Validators.pattern('^[a-zA-Z]*$'),
    ]),
    stateEnable: new FormControl('', [Validators.pattern('^[a-zA-Z0-9*#]*$')]),
    govtIp1: new FormControl('', []),
    port1: new FormControl('', [SharedValidators.portValidation]),
    govtIp2: new FormControl('', []),
    port2: new FormControl('', [SharedValidators.portValidation]),
    secondaryStateEnable: new FormControl('', [
      Validators.pattern('^[a-zA-Z0-9*#]*$'),
    ]),
    govtIp3: new FormControl('', []),
    port3: new FormControl('', [SharedValidators.portValidation]),
    govtIp4: new FormControl('', []),
    port4: new FormControl('', [SharedValidators.portValidation]),
    createdBy: [''],
  });
  firmwareForm: FormGroup = this.formBuilder.group({
    firmwareVersion: ['', [SharedValidators.requiredAndNoEmptySpaces]],
    file: ['', [SharedValidators.requiredAndNoEmptySpaces]],
    fileName: ['', [SharedValidators.requiredAndNoEmptySpaces]],
    description: [''],
    expectedFirmwareVersion: ['', [SharedValidators.requiredAndNoEmptySpaces]],
    createdBy: [''],
  });
  private _onDestroy = new Subject<void>();

  userPermission = [];
  userRole = '';
  loggedId = '';

  govtServersCreate = false;
  govtServersUpdate = false;
  govtServersPermissionCreate = false;
  govtServersPermissionDelete = false;
  govtServersPermissionUpdate = false;

  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public datePipe: DatePipe,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    this.setGovernmentServerForm();
    this.setFirmwareForm();
    this.setGovernmentServerData();
  }

  // Cleanup subscriptions
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userRole = this.apiMicroservice.decryptData(
      sessionStorage.getItem('userRole') || ''
    );
    this.loggedId = this.apiMicroservice.decryptData(
      sessionStorage.getItem('userRefId') || ''
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (
          element.pageName === 'Government Servers' &&
          element.view === false
        ) {
          this.navigateBack();
        }
        if (
          element.pageName === 'Government Servers' &&
          element.create === true
        ) {
          this.govtServersPermissionCreate = true;
        }
        if (
          element.pageName === 'Government Servers' &&
          element.delete === true
        ) {
          this.govtServersPermissionDelete = true;
        }
        if (
          element.pageName === 'Government Servers' &&
          element.update === true
        ) {
          this.govtServersPermissionUpdate = true;
        }
      }
    );
  }

  setGovernmentServerData() {
    this.serverId =
      this.serverId || this.route.snapshot.paramMap.get('id') || '';
    if (this.serverId) {
      this.govtServersUpdate = true;
      this.govtServersCreate = false;
      this.fetchGovernmentServerData(this.serverId);
    } else {
      this.govtServersUpdate = false;
      this.govtServersCreate = true;
    }
  }

  setGovernmentServerForm() {
    this.govtServersForm = this.formBuilder.group({
      state: new FormControl('', [SharedValidators.requiredAndNoEmptySpaces]),
      stateAbbreviation: new FormControl('', [
        SharedValidators.requiredAndNoEmptySpaces,
        Validators.pattern('^[a-zA-Z]*$'),
      ]),
      stateEnable: new FormControl('', [
        Validators.pattern('^[a-zA-Z0-9*#]*$'),
      ]),
      govtIp1: new FormControl('', []),
      port1: new FormControl('', [SharedValidators.portValidation]),
      govtIp2: new FormControl('', []),
      port2: new FormControl('', [SharedValidators.portValidation]),
      secondaryStateEnable: new FormControl('', [
        Validators.pattern('^[a-zA-Z0-9*#]*$'),
      ]),
      govtIp3: new FormControl('', []),
      port3: new FormControl('', [SharedValidators.portValidation]),
      govtIp4: new FormControl('', []),
      port4: new FormControl('', [SharedValidators.portValidation]),
      createdBy: [this.loggedId],
    });
  }

  setFirmwareForm() {
    this.firmwareForm = this.formBuilder.group({
      firmwareVersion: ['', [SharedValidators.requiredAndNoEmptySpaces]],
      file: ['', [SharedValidators.requiredAndNoEmptySpaces]],
      fileName: ['', [SharedValidators.requiredAndNoEmptySpaces]],
      description: [''],
      expectedFirmwareVersion: [
        '',
        [SharedValidators.requiredAndNoEmptySpaces],
      ],
      createdBy: [this.loggedId],
    });
  }

  fetchGovernmentServerData(serverId: string) {
    this.spinner.show();
    this.updateButton = true;
    this.apiMicroservice.getGovtServerListRefId(serverId).subscribe({
      next: (res) => {
        this.spinner.hide();

        if (res.status && res.data && res.data.length > 0) {
          const data = res.data[0];

          const firmwareList = data.firmware || data.firmwareIds || [];
          this.firmwareList = [...firmwareList];
          this.totalLength = firmwareList.length;

          this.govtServersForm.patchValue({
            state: data.state,
            stateAbbreviation: data.stateAbbreviation,
            stateEnable: data.stateEnable,
            govtIp1: data.govtIp1,
            port1: data.port1,
            govtIp2: data.govtIp2,
            port2: data.port2,
            secondaryStateEnable: data.secondaryStateEnable,
            govtIp3: data.govtIp3,
            port3: data.port3,
            govtIp4: data.govtIp4,
            port4: data.port4,
            createdBy: data.createdBy,
          });
        } else {
          this.apiMicroservice.openSnackbar(
            'No data found for the specified server.'
          );
        }
      },
      error: (err: HttpErrorResponse) => {
        this.spinner.hide();
        this.apiMicroservice.openSnackbar(err.message);
      },
    });
  }

  addFirmware() {
    if (this.firmwareForm.invalid) {
      SharedValidators.markAllAsTouched(this.firmwareForm);
      return;
    }

    const newFirmware = this.firmwareForm.value;

    // Find duplicates
    const duplicateList = this.firmwareList.filter(
      (fw: { firmwareVersion: string }) =>
        fw.firmwareVersion === newFirmware.firmwareVersion
    );

    if (duplicateList.length > 0) {
      const duplicateDetails = duplicateList
        .map(
          (dup: { firmwareVersion: string }) =>
            `Duplicate Field: Firmware Version, Value: ${dup.firmwareVersion}`
        )
        .join('\n');

      alert(
        `The firmware you are trying to add has the following duplicates:\n\n${duplicateDetails}\n\nPlease resolve them before proceeding.`
      );
      return; // Prevent API call
    }

    const payload = {
      serverId: this.serverId,
      firmware: [newFirmware],
    };

    this.spinner.show();

    this.apiMicroservice.addFirmware(payload).subscribe({
      next: (res) => {
        this.spinner.hide();

        if (!res.status) {
          return this.apiMicroservice.openSnackbar(res.message);
        }

        this.apiMicroservice.openSnackbar('Firmware added successfully');

        this.closeModal();
        this.ngOnInit();
      },
      error: (err: HttpErrorResponse) => {
        this.spinner.hide();
        this.apiMicroservice.openSnackbar(
          err.error?.message || 'Something went wrong'
        );
      },
    });
  }

  deleteFirmware(firmwareId: string) {
    if (confirm('Are you sure to Delete')) {
      this.apiMicroservice.deleteFirmwareVersion(firmwareId).subscribe({
        next: (res) => {
          if (res.status) {
            this.ngOnInit();
            this.apiMicroservice.openSnackbar(res.message);
          } else {
            this.apiMicroservice.openSnackbar(res.message);
          }
        },
        error: (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          this.apiMicroservice.openSnackbar(ERROR.error.message);
        },
      });
    }
  }

  updateFirmwareExpectedFirmwareVersionData(firmwareId: string) {
    let input: string = prompt('Enter New Expected Firmware Version', '') || '';

    // ❌ If user cancels
    if (input === null) return;

    // Trim
    input = input.trim();

    // ❌ Empty check
    if (!input) {
      this.apiMicroservice.openSnackbar(
        'Expected Firmware Version is required'
      );
      return;
    }

    if (confirm('Are you sure to Edit this Expected Firmware Version?')) {
      this.apiMicroservice
        .updateFirmwareExpectedFirmwareVersionData(firmwareId, {
          expectedFirmwareVersion: input,
        })
        .subscribe({
          next: (res) => {
            if (res.status) {
              this.ngOnInit();
              this.apiMicroservice.openSnackbar(res.message);
            } else {
              this.apiMicroservice.openSnackbar(res.message);
            }
          },
          error: (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            this.apiMicroservice.openSnackbar(ERROR.error.message);
          },
        });
    }
  }

  submitGovtServers() {
    if (this.govtServersForm.invalid) {
      SharedValidators.markAllAsTouched(this.govtServersForm);
      return;
    } else {
      this.addGovtServers();
    }
  }

  updateGovtServers() {
    if (this.govtServersForm.invalid) {
      SharedValidators.markAllAsTouched(this.govtServersForm);
      return;
    }

    const payload = {
      ...this.govtServersForm.value,
    };

    this.spinner.show();

    this.apiMicroservice.updateServer(this.serverId, payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.apiMicroservice.openSnackbar(res.message);
          this.updateButton = false;
          this.router.navigate(['govt-servers']);
        } else {
          this.apiMicroservice.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.apiMicroservice.openSnackbar(ERROR.error.message);
      },
    });
  }

  /**
   * Finds duplicates in firmware array for firmwareVersion or fileName.
   */
  findFieldDuplicates(firmware: { firmwareVersion: string }[]) {
    const duplicates: {
      field: string;
      value: string;
    }[] = [];
    const fieldTrackers = {
      firmwareVersion: new Map(),
    };

    firmware.forEach((item) => {
      // Check for duplicate firmwareVersion
      if (
        item.firmwareVersion &&
        fieldTrackers.firmwareVersion.has(item.firmwareVersion)
      ) {
        duplicates.push({
          field: 'Firmware Version',
          value: item.firmwareVersion,
        });
      } else {
        fieldTrackers.firmwareVersion.set(item.firmwareVersion, true);
      }
    });

    return duplicates;
  }

  addGovtServers() {
    const payload = {
      ...this.govtServersForm.value,
    };

    this.spinner.show();
    this.apiMicroservice.saveServerData(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.apiMicroservice.openSnackbar(res.message);
          this.serverId = res.data.data._id;
          this.ngOnInit();
        } else {
          this.apiMicroservice.openSnackbar(res.message);
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this.apiMicroservice.openSnackbar(ERROR.error.message);
        this.spinner.hide();
      },
    });
  }

  onPageChange(event: number) {
    this.page = event;
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
  }

  file_upload(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = input.files[0];
      const filename = files.name;
      if (filename.includes('.bin')) {
        this.convertToBase64(files);
      } else {
        this.firmwareForm.get('file')?.markAsTouched();
        this.firmwareForm.patchValue({ file: '' });
        this.apiMicroservice.openSnackbar('Please Select Only Bin File');
      }
    }
  }

  convertToBase64(file: File) {
    const observable = new Observable<string>(
      (subscriber: Subscriber<string>) => {
        this.readFile(file, subscriber);
      }
    );
    observable.subscribe((d: string) => {
      const base64Str = d.split(',');
      const base64StrFile = base64Str[1];

      this.firmwareForm.patchValue({
        file: base64StrFile,
        fileName: file.name,
      });
    });
  }

  readFile(file: File, subscriber: Subscriber<string>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result as string);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  // downloadFirmware(i: number) {
  //   if (!this.firmwareList || i < 0 || i >= this.firmwareList.length) {
  //     this.apiMicroservice.openSnackbar('Invalid firmware row selected');
  //     return;
  //   }

  //   const row: { file: string; fileName: string } = this.firmwareList[i];

  //   const base64 = row.file;
  //   const fileName = row.fileName || 'firmware.bin';

  //   if (!base64) {
  //     this.apiMicroservice.openSnackbar('No file found to download');
  //     return;
  //   }

  //   this.generateBinFile(base64, fileName);
  // }

  // generateBinFile(base64: string, fileName: string) {
  //   const binaryData = atob(base64); // decode base64 → binary string

  //   const byteNumbers = new Array(binaryData.length);
  //   for (let i = 0; i < binaryData.length; i++) {
  //     byteNumbers[i] = binaryData.charCodeAt(i);
  //   }

  //   const byteArray = new Uint8Array(byteNumbers);

  //   const blob = new Blob([byteArray], { type: 'application/octet-stream' });
  //   const url = window.URL.createObjectURL(blob);

  //   const a = document.createElement('a');
  //   a.href = url;
  //   a.download = fileName;
  //   a.click();

  //   window.URL.revokeObjectURL(url);
  // }

  openFirmwareModal() {
    document
      ?.getElementById('firmwareModal')
      ?.parentElement?.classList.add('active');
    this.setFirmwareForm();
  }

  closeModal() {
    document
      ?.getElementById('firmwareModal')
      ?.parentElement?.classList.remove('active');
    this.firmwareForm.reset();
  }

  redirect(to: string): void {
    this.router.navigate([to]);
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
